export const CHECKOUT_STEP_KIND_PARAM = "stepKind";

export type CheckoutStepKindConfig = {
  zeroPriceSubmitTitleKey: string;
};

export const CHECKOUT_STEP_KIND_CONFIG: Record<string, CheckoutStepKindConfig> = {
  academySwimmingRecruitment: {
    zeroPriceSubmitTitleKey: "zloz_rezerwacje",
  },
};

export function getCheckoutSubmitTitle(
  stepKind: string | null,
  total: number,
  t: (key: string) => string,
): string {
  if (!stepKind || total !== 0) {
    return t("kupuje_z_obowiazkiem_zaplaty");
  }
  const config = CHECKOUT_STEP_KIND_CONFIG[stepKind];
  if (!config) {
    return t("kupuje_z_obowiazkiem_zaplaty");
  }
  return t(config.zeroPriceSubmitTitleKey);
}
